import * as React from 'react';
import { useSelector } from 'react-redux';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { selectBreadcrumbs } from '../../selectors/newbuilding';

export const BreadcrumbsContainer: React.FC = () => {
  const breadcrumbs = useSelector(selectBreadcrumbs);

  return <Breadcrumbs breadcrumbs={breadcrumbs} />;
};
